import controller from './zip-arbo.controller';
import template from './zip-arbo.html';

export default {
	template,
	bindings: {
		selectedForm: '<',
		forms:        '<',
		formTreeData: '<ngModel',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
